"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.adjustRoute = exports.isGeometryLoaded = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

// this function ensures that the geometry API is loaded before we try to decode an encoded polyline
var isGeometryLoaded = function isGeometryLoaded() {
  var _window, _window$google, _window$google$maps, _window$google$maps$g;

  return Boolean(typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : (_window$google = _window.google) === null || _window$google === void 0 ? void 0 : (_window$google$maps = _window$google.maps) === null || _window$google$maps === void 0 ? void 0 : (_window$google$maps$g = _window$google$maps.geometry) === null || _window$google$maps$g === void 0 ? void 0 : _window$google$maps$g.encoding));
}; // the routes array we receive from HDC from its GDP query to the Trulia API has all longitudes and latitudes
// with the decimal point one place too far to the right. Ex: {-340, 1200} needs to be {-34, 120}. This function
// makes this small correction. 


exports.isGeometryLoaded = isGeometryLoaded;

var adjustRoute = function adjustRoute(route) {
  return route.map(function (latlng) {
    var result = {};
    result.lat = latlng.lat() / 10;
    result.lng = latlng.lng() / 10;
    return result;
  });
};

exports.adjustRoute = adjustRoute;

var Route =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Route, _Component);

  function Route(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.displayRoute = function () {
      var _google$maps$geometry, _google$maps$geometry2;

      var decodedRoute = (_google$maps$geometry = google.maps.geometry.encoding) === null || _google$maps$geometry === void 0 ? void 0 : (_google$maps$geometry2 = _google$maps$geometry.decodePath) === null || _google$maps$geometry2 === void 0 ? void 0 : _google$maps$geometry2.call(_google$maps$geometry, _this.props.route);
      var path = adjustRoute(decodedRoute);
      _this.polyline = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: _this.props.color,
        strokeOpacity: 0.8,
        strokeWeight: 4
      });

      _this.polyline.setMap(_this.props.gmap);
    };

    _this.polyline = null;
    return _this;
  }

  var _proto = Route.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (isGeometryLoaded()) {
      this.displayRoute();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.polyline) {
      this.polyline.setMap(null);
    }

    ;

    if (isGeometryLoaded()) {
      this.displayRoute();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.polyline.setMap(null);
  };

  _proto.render = function render() {
    return null;
  };

  return Route;
}(_react.Component);

Route.propTypes = process.env.NODE_ENV !== "production" ? {
  gmap: _propTypes.default.shape({}).isRequired,
  route: _propTypes.default.string,
  color: _propTypes.default.string
} : {};
var _default = Route;
exports.default = _default;